import { RequestApiKpiBase, RequestApiPrivate } from './axios';
import { WsCode } from './wsCode';

type AuthUser = {
  id: number;
  groups: Group;
};

type Group = {
  id: number;
  name: String;
  status: number;
};

export const generateGPerformanceToken = async (
  authUser: AuthUser,
  expiresAt: number
) => {
  try {
    const payload = {
      id: authUser.id,
      groups: authUser.groups,
      expired_in: expiresAt
    };
    const { data } = await RequestApiKpiBase.post(
      WsCode.auth.generateToken,
      payload
    );
    RequestApiPrivate.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${data?.data?.access_token}`;
    return data;
  } catch (error) {
    throw error;
  }
};
